module.exports = __webpack_public_path__ + "img/banners_warning_with_undo.d4539141.webp";